import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/youtube-white-icon.svg")